import type { GetSuggestionDetailResponse } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import { readBulkEditScope } from '../utils/assignmentBulkEditSession';
import { assignmentLineFromSuggestionDetail } from '../utils/suggestionDetailLine';

export function overrideSectionBulkScope(
  highlightCartKey: string | null,
  suggestion: GetSuggestionDetailResponse,
) {
  const bulkScope = readBulkEditScope(
    highlightCartKey,
    suggestion.suggestionId,
  );
  const linesForBulk =
    bulkScope.lines.length > 0
      ? bulkScope.lines
      : [assignmentLineFromSuggestionDetail(suggestion)];
  const bulkLineCount = bulkScope.isBulk ? bulkScope.count : 1;
  return { bulkLineCount, linesForBulk };
}
